import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import { classNames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';
import { getCommentCount } from '../../../services/api';

class NewsStream extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    countMap = {};
    state = {
        countMapCache: {},
    };
    componentDidMount() {
        this.getCount();
    }
    // 获取评论列表
    async getCount() {
        try {
            // 生成评论地址的数组
            const urlArr = [];
            const keys = [];
            const { newsstream } = this.props.content;
            const { countMapCache } = this.state;

            for (const key in this.countMap) {
                keys.push(key);
                urlArr.push(newsstream[this.countMap[key]].commentUrl);
            }

            const data = await getCommentCount(urlArr);

            data.forEach((value, index) => {
                countMapCache[keys[index]] = value.allcount;
            });

            this.setState({ countMapCache: { ...countMapCache } });
        } catch (err) {
            console.error(err);
        }
    }
    listView(list = []) {
        const { countMapCache } = this.state;

        return list.map((item, index) => {
            const url = formatUrl(item.url);
            const query = `docUrl=${item.commentUrl}&docName=${item.title}&skey=${item.skey}&pcUrl=${item.url}`;
            const pinglunUrl = `https://gentie.ifeng.com/view.html?${query}`;

            this.countMap[item.id] = index;

            return (
                <li key={index}>
                    <a className={styles.imgLink} href={url} target="_blank" rel={relText}>
                        <img src={formatImage(item.thumbnails, 254, 150)} alt={item.title} width={254} height={150} />
                    </a>
                    <h4 className={styles.title}>
                        <a href={url} title={item.title} target="_blank" rel={relText}>
                            {item.title}
                        </a>
                    </h4>
                    <p className={styles.desc}>{item.summary}</p>
                    <div className={styles.pinglunBox}>
                        <a href={pinglunUrl} target="_blank" rel={relText}>
                            <img src={require('./pinglun.png')} />
                            {countMapCache[item.id] || 0}
                        </a>
                    </div>
                </li>
            );
        });
    }
    render() {
        const { newsstream, columnId, page, endPage, channel } = this.props.content;
        /* eslint-disable */
        const url = `${gongyiUrl}/shanklist/gongyi/innovation/${columnId}/`;
        /* eslint-enable */

        return (
            <div className={styles.box}>
                <ul className={classNames(styles.list, 'clearfix')}>{this.listView(newsstream)}</ul>
                <div className={styles.pageBox}>
                    {page <= 1 ? null : (
                        <a className={styles.nextpage} href={`${url}${page <= 1 ? 1 : page - 1}`}>
                            上一页
                        </a>
                    )}
                    {page >= endPage ? null : (
                        <a className={styles.nextpage} href={`${url}${page >= endPage ? endPage : page + 1}`}>
                            下一页
                        </a>
                    )}
                </div>
                <a className={styles.back} href={formatUrl(channel[0].domain)}>
                    返回
                </a>
            </div>
        );
    }
}

export default NewsStream;
